import { aivoChatSendMessage } from "./utils";
import {
  INTERACTION,
  ILastQuestionInformation,
  CALL_TO_ACTION_MESSAGES,
} from "./constants";

let lastQuestionInformation: ILastQuestionInformation,
  evasionCount: number = 0;

export function showAdviserButtonForTwoConsecutiveUnansweredQuestions(
  type: string,
  question: string
): any {
  if (type === INTERACTION.TYPES.EVASION) evasionCount++;

  if (
    evasionCount >= INTERACTION.CONSECUTIVE_UNANSWERED_QUESTIONS_TO_SHOW_ADVISER_BUTTON &&
    type === INTERACTION.TYPES.EVASION &&
    lastQuestionInformation?.type === INTERACTION.TYPES.EVASION
  ) {
    aivoChatSendMessage(CALL_TO_ACTION_MESSAGES.ADVISER);
    evasionCount = 0;
  }

  lastQuestionInformation = {
    type: type,
    question: question,
  };
}
